<template>
  <div class="col-lg-10" style="margin-top: 20px; margin-left: -20px;">
    <table v-loading="showLoading" class="JY-order-one JY-order-oneB" width="100%;">
      <thead>
        <tr>
          <th style="width:32%">货物始发地及目的地</th>
          <th class="taC" style="width:15%">运单</th>
          <th class="taC" style="width:10%">承运人</th>
          <th class="taC" style="width:20%">报价</th>
          <th class="taC" style="width:12%">状态</th>
          <th class="taC">操作</th>
        </tr>
      </thead>
    </table>
    <div v-for="item in items" :key="item.ID" class="JY-order-one JY-order-one-transport">
      <table width="100%;">
        <thead>
          <tr>
            <th colspan="3">
              <span style="font-weight: 600;">{{item.CreateTime}}</span>
              <span style="margin-left:10px;">订单号：{{item.OrderNo}}</span>
              <span style="margin-left:10px;">业务单号：{{item.YeWuDanHao}}</span>
            </th>
            <th class="taC"></th>
            <th class="taC"></th>
            <th class="taC"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width:32%">
              <p>
                <strong>
                  出发地
                  <span class="jobs">{{item.ChuFaDi}}</span>
                </strong>
                <br />
                <strong>
                  到达地
                  <span class="jobs">{{item.DaoDaDi}}</span>
                </strong>
              </p>
            </td>
            <td class="taL" style="width:15%">
              <p>
                <span>
                  运单数：
                  <strong>{{item.YunDanNum}}</strong>
                </span>
                <br />
                <span>
                  总车数：
                  <strong>{{item.TotalCarNum}}车</strong>
                </span>
                <br />
                <span>
                  预计承运：
                  <strong>{{item.BaoJiaLeiXing=='按吨'?(item.YuJiDun_Car_Num)+'吨':''+item.YuJiDun_Car_Num+'车'}}</strong>
                </span>
              </p>
            </td>
            <td class="taC" style="width:10%">{{item.ChengYunUserName}}</td>
            <td class="taL" style="width:20%">
              <p>
                <span>
                  报价方式：
                  <strong>{{item.BaoJiaLeiXing}}</strong>
                </span>
                <br />
                <span>
                  价格：
                  <strong>{{formatNumber(item.BaoJiaLeiXing=='按吨'?(item.DanJia+'(总计)'):(item.DanJia+'/吨'))}}</strong>
                </span>
                <br />
                <span>
                  每车油卡金额：
                  <strong>{{formatNumber(item.YouKaJinE)}}元</strong>
                </span>
              </p>
            </td>
            <td class="taC" style="width:12%">
              <p>
                {{item.Status}}
                <br />
                <strong style="color: #df0024;">{{item.OrderStatus}}</strong>
              </p>
            </td>
            <td class="taC" style="border-right: 0;">
              <p>
                <a href="javascript:;" @click="openDetail(item)">查看详情</a>
                <br />
                <a href="javascript:;" @click="importYunDan(item.ID)">导入运单</a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
      <el-pagination
        @current-change="loadMore"
        background
        :page-size="search.PageSize"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="协议详情" width="50%" top="1vh" :visible.sync="dialogVisible">
      <agreement :item="currentItem"></agreement>
      <p v-if="currentItem.Status!='已确认'" style="text-align: center;">
        <el-checkbox v-model="inputAgree1"></el-checkbox>
        <a @click="openCondition1" href="javascript:;">承运协议</a> &nbsp;
        <el-checkbox v-model="inputAgree2"></el-checkbox>
        <a @click="openCondition2" href="javascript:;">收款协议</a>
      </p>
      <div v-if="currentItem.Status!='已确认'" class="center">
        <el-button :disabled="!(inputAgree1&&inputAgree2)" @click="agree" type="primary">同意协议</el-button>
      </div>
    </el-dialog>
    <el-dialog title="承运协议" :visible.sync="dialogVisible1" width="70%" center>
      <condition :id="id1"></condition>
    </el-dialog>
    <el-dialog title="收款协议" :visible.sync="dialogVisible2" width="70%" center>
      <condition :id="id2"></condition>
    </el-dialog>
    <el-dialog title="导入运单" :visible.sync="importVisible" width="400px">
      <div>
        <br />
        <a href="javascript:;" @click="downloadExcel">点击下载运单模板.xlsx</a>
        <br />
        <br />
      </div>
      <div>
        <el-upload
          :on-success="importResult"
          class="upload-demo"
          drag
          :headers="token"
          :action="importUrl"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过2M</div>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../../api";
import util from "../../libs/util";
import agreement from "../../components/agreement";
import condition from "../../components/condition";
export default {
  components: {
    agreement,
    condition
  },
  data() {
    return {
      token: {
        Authorization: util.cookies.get("access_token")
      },
      id1: "d6bb88e2-cfcd-442f-a521-5d49f76bbe81",
      id2: "b3928841-5f6a-494b-ad19-3524d637e981",
      dialogVisible: false,
      importVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      showLoading: false,
      inputAgree1: false,
      inputAgree2: false,
      currentItem: {},
      items: [],
      total: 0,
      search: {
        PageNo: 1,
        PageSize: 20
      },
      importUrl: ""
    };
  },
  methods: {
    downloadExcel() {
      var src = process.env.BASE_API + "/Apps/JYJYManage/Preview/DownloadYunDanTemplate";
      document.getElementById("download_iframe").src = src;
    },
    importResult(response) {
      let _this = this;
      if (response.Succeed) {
        document.getElementById("driver-orders").click();
        _this.$router.push("/driver/orders");
      } else {
        _this.$message({
          message: "导入失败," + response.Message,
          type: "error"
        });
      }
    },
    importYunDan(id) {
      this.importVisible = true;
      this.importUrl = process.env.BASE_API+'/Apps/JYJYManage/ClientApi/ImportYunDan?agreementId='+id;
    },
    formatNumber(n) {
      return util.getThousandNumber(n);
    },
    openCondition1() {
      this.dialogVisible1 = true;
    },
    openCondition2() {
      this.dialogVisible2 = true;
    },
    openDetail(item) {
      this.currentItem = item;
      this.dialogVisible = true;
    },
    agree() {
      let _this = this;
      _this
        .$confirm("同意协议之后将不能修改, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          api
            .saveAgreement({
              model: _this.currentItem
            })
            .then(res => {
              if (!res.data.Succeed) {
                _this.$message({
                  message: "保存失败," + res.data.Message,
                  type: "error"
                });
                return;
              } else {
                _this.dialogVisible = false;
                _this.reload();
              }
            });
        })
        .catch();
    },
    load() {
      let _this = this;
      _this.showLoading = true;
      api.getAgreements(_this.search).then(res => {
        _this.showLoading = false;
        if (res.data.Succeed) {
          _this.items = res.data.Data.Data;
          _this.total = res.data.Data.totalItemCount;
        }
      });
    },
    reload() {
      this.search.PageNo = 1;
      this.load();
    },
    loadMore(n) {
      this.search.PageNo = n;
      this.load();
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style>
.JY-items-list,
.JY-items-search {
  width: 100%;
}
span.el-tag {
  margin-right: 5px;
}
.el-table th.gutter {
  display: table-cell !important;
}
.JY-order-one a {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/Driver/DriverAgreement.vue